var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2,0 L11,0 L11,9 L0,9 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13,0 L22,0 C23.1045695,-2.02906125e-16 24,0.8954305 24,2 L24,16 L13,16 L13,0 Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13,18 L24,18 L24,22 C24,23.1045695 23.1045695,24 22,24 L13,24 L13,18 Z",
      "opacity": "0.199999988"
    }
  }), _c('path', {
    attrs: {
      "d": "M0,11 L11,11 L11,24 L2,24 C0.8954305,24 1.3527075e-16,23.1045695 0,22 L0,11 Z",
      "opacity": "0.5"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }